import _extends from '@babel/runtime/helpers/extends';
import 'classnames';
import React, { useContext } from 'react';
import { SideNavContext } from './index.js';

var MinimizeToggle = function MinimizeToggle(_ref) {
  var otherProps = _extends({}, _ref);
  useContext(SideNavContext);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: "C-SideNav__MinimizeToggle C-ListItem__item --clickable"
  }, otherProps));
};
MinimizeToggle.displayName = 'SideNav.MinimizeToggle';

export { MinimizeToggle as default };
